The details of the `CandidateProcessHistoryItem` created.
